import React, { useEffect } from "react";
import { BonusesSection } from "./components/BonusesSection";
import { ComparisonSection } from "./components/ComparisonSection";
import { EliteSection } from "./components/EliteSection";
import { Footer } from "./components/Footer";
import { Hero } from "./components/Hero";
import { OfferSection } from "./components/OfferSection";
import { ProblemsSection } from "./components/ProblemsSection";
import { SystemSection } from "./components/SystemSection";
import { Testimonials } from "./components/Testimonials";
import { TomesSection } from "./components/TomesSection";
import { FaqSection, GuaranteeSection } from "./components/TrustSections";
export function App() {
  useEffect(() => {
    document.title = "Atletismo Resuelto™ — Sistema Completo para Profes de Atletismo";
    const description = "7 tomos, 5 bonos, 60+ clases y guías profesionales para planificar, enseñar y evaluar atletismo sin improvisar. Acceso digital inmediato.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-[#080B14] font-heading text-white antialiased selection:bg-[#C81724] selection:text-white" data-id="element-0" data-mp="3rd1all5o5hp3">
      <main data-id="element-1" data-mp="2zlld2w2kqak3">
        <Hero data-id="element-2" data-mp="2zm4ywnvchj3e" />
        <Testimonials data-id="element-3" data-mp="2zmem63p09c5e" />
        <ProblemsSection data-id="element-4" data-mp="2zn6biws0edn8" />
        <SystemSection data-id="element-5" data-mp="33mf25srr5vek" />
        <TomesSection data-id="element-6" data-mp="33lx0uhq8gqzs" />
        <BonusesSection data-id="element-7" data-mp="33n6yj5t6bx5w" />
        <EliteSection data-id="element-8" data-mp="33oi337ug18y2" />
        <OfferSection data-id="element-9" data-mp="38m1e7yvuh5ls" />
        <Testimonials expanded data-id="element-10" data-mp="38kqcs5pvg9xu" />
        <GuaranteeSection data-id="element-11" data-mp="38kgmsi4tu2s5" />
        <FaqSection data-id="element-12" data-mp="3dkuu1xylt8p4" />
        <ComparisonSection data-id="element-13" data-mp="3dle46si0issl" />
        <OfferSection final data-id="element-14" data-mp="3dlnsmbnesrw6" />
      </main>
      <Footer data-id="element-15" data-mp="3dii716dzo857" />
    </div>;
}